import { GET_REPORT_DATA } from "../../../../config/constants";
import { withType } from "../../../utils/actionOperations";
import { ApiBase } from "../../../utils/apiBase";
import { getProjectIdAndOrgId } from "../../../utils/apiUtils";
import {
    FETCH_PDF_DATA_STARTED,
    FETCH_PDF_DATA_SUCCESS,
    FETCH_PDF_DATA_FAILED,
} from "../../constants";

export const getResultData = (payload) => {
    const apiBaseInstance = new ApiBase();
    return (dispatch) => {
        dispatch(withType(FETCH_PDF_DATA_STARTED, {}));
        apiBaseInstance.instance.post(GET_REPORT_DATA, { ...getProjectIdAndOrgId(payload) }).then((stored) => {
            dispatch(withType(FETCH_PDF_DATA_SUCCESS, { data: stored }));
        })
            .catch((err) => {
                dispatch(withType(FETCH_PDF_DATA_FAILED, { error: err }));
            });
    };
};
